/* eslint-disable no-useless-escape */
import VMasker from 'vanilla-masker';

import cloneDeep from 'lodash.clonedeep';
import moment from 'moment-timezone';
export function clone(value) {
  return cloneDeep(value);
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function getMonthDateRange(year, month) {
  var startDate = moment([year, month, 1]).locale('pt-br');
  var endDate = moment(startDate).endOf('month');
  return { start: startDate, end: endDate };
}

export var handleChange = (componente, obj, name, value, type, callback) => {
  let state = {};

  if (!obj) {
    state = { [name]: type ? maskFormate(value, type) : value };
  } else {
    state = { [obj]: { ...componente.state[obj], [name]: type ? maskFormate(value, type) : value } };
  }

  componente.setState(state, () => {
    if (callback) callback();
  });
};

export function getProps(componente) {
  if (!componente) {
    return alert('getProps falta componente');
  }
  try {
    var nav = componente.props.history.location;
    return nav;
  } catch (error) {
    return {};
  }
}

export function cutString(desc, size, format = '...') {
  if (!desc) {
    return '';
  }
  let length = size ? size : 100;

  if (desc.length > length) {
    return desc.substring(0, length) + format;
  } else {
    return desc;
  }
}

export function formatMoney(value) {
  if (value == null || value == undefined || value == '') {
    value = 0;
  }
  var a = VMasker.toMoney(value, {
    // Decimal precision -> "90"
    precision: 2,
    // Decimal separator -> ",90"
    separator: ',',
    // Number delimiter -> "12.345.678"
    delimiter: '.',
    // Money unit -> "R$ 12.345.678,90"
    unit: 'R$',
    // Money unit -> "12.345.678,90 R$"
    // suffixUnit: 'R$',
    // Force type only number instead decimal,
    // masking decimals with ",00"
    // Zero cents -> "R$ 1.234.567.890,00"
    zeroCents: true,
  });

  return a;
}

export function formatNumero(value) {
  if (value == null || value == undefined || value == '') {
    value = 0;
  }
  var a = VMasker.toMoney(value, {
    precision: 2,
    separator: ',',
    delimiter: '.',
  });

  return a;
}

export function replaceAll(string, str, key) {
  try {
    if (!string) {
      return '';
    }
    if (!str) {
      return string;
    }
    if (!key) {
      key = '';
    }
    return string.replace(new RegExp(str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), key);
  } catch (e) {
    return string;
  }
}

export function maskFormate(value, mask) {
  if (!value) return '';
  if (mask == 'int') {
    value = VMasker.toNumber(value);
  } else if (mask == 'doub') {
    if (!value) {
      value = 0;
    } else {
      value = parseFloat(value);
    }
    value = value ? value : 0;
  } else if (mask == 'phone') {
    var telMask = ['(99) 9999-9999', '(99) 99999-9999', '9999 999 9999'];
    if (contemString(limparStringNumber(value), '0800')) {
      value = VMasker.toPattern(value, telMask[2]);
    } else {
      value = VMasker.toPattern(value, telMask[limparStringNumber(value).length < 11 ? 0 : 1]);
    }
  } else if (mask == 'doc') {
    value = VMasker.toPattern(value, validarCadastroDocCpf(value) == 1 ? '999.999.999-99' : '99.999.999/9999-99');
  } else if (mask) {
    value = VMasker.toPattern(value, mask);
  }
  return value;
}

export function validarCadastroDocCpf(doc) {
  if (doc) {
    return limparStringNumber(doc).length <= 11;
  } else {
    return false;
  }
}

function limparStringNumber(value) {
  if (value) {
    return value.replace(/[^\d]+/g, '');
  } else {
    return '';
  }
}

export function contemString(string, key) {
  if (!string || !key) {
    return false;
  }
  try {
    string = string + '';
    if (string && string.indexOf(key) >= 0) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
}

export function parseNumeroDuasCasas(string) {
  if (!string) {
    return 0.0;
  }
  try {
    string = string + '';
    var val = string.replace(',', '.');
    var nnn = parseFloat(val);
    if (!nnn) {
      nnn = 0.0;
    }
    var num = nnn.toFixed(2);
    if (!num || num < 0) {
      num = 0.0;
    }
    return num;
  } catch (e) {
    console.log(e);
    return 0.0;
  }
}

export function cleanString(s) {
  if (!s) {
    return '';
  }
  var r = s; //.toLowerCase();
  r = r.replace(new RegExp(/\s/g), '');
  r = r.replace(new RegExp(/[àáâãäå]/g), 'a');
  r = r.replace(new RegExp(/æ/g), 'ae');
  r = r.replace(new RegExp(/ç/g), 'c');
  r = r.replace(new RegExp(/[èéêë]/g), 'e');
  r = r.replace(new RegExp(/[ìíîï]/g), 'i');
  r = r.replace(new RegExp(/ñ/g), 'n');
  r = r.replace(new RegExp(/[òóôõö]/g), 'o');
  r = r.replace(new RegExp(/œ/g), 'oe');
  r = r.replace(new RegExp(/[ùúûü]/g), 'u');
  r = r.replace(new RegExp(/[ýÿ]/g), 'y');
  r = r.replace(new RegExp(/\W/g), '');
  return r;
}

export function testEmpty(val, testarBooleanFalse) {
  if (val === undefined) {
    return false;
  }
  if (val === null) {
    return false;
  }
  if (val === '') {
    return false;
  }
  if (testarBooleanFalse && val === false) {
    return false;
  }
  return true;
}
